import {
  useCancellationReasons,
  useCancellationReasonSettings,
} from "@coaching-culture/api-client";
import {
  Box,
  Button,
  Flex,
  FormSelect,
  FormToggle,
  Loader,
  ReactModal,
  Text,
} from "@coaching-culture/ui";
import { useState } from "react";

export type CancelConversationModalProps = {
  onCancel: () => void;
  onConfirm: (cancelAll: boolean, reason: string) => void;
  isOpen: boolean;
};

export const CancelConversationModal = ({
  onCancel,
  onConfirm,
  isOpen,
}: CancelConversationModalProps) => {
  const cancellationReasons = useCancellationReasons();
  const settings = useCancellationReasonSettings();

  const [reason, setReason] = useState("");
  const [all, setAll] = useState(false);

  const reasonRequired =
    (settings.data?.requireReason ?? false) &&
    (cancellationReasons.data ?? []).length > 0;

  const options = [
    {
      value: "",
      label: reasonRequired ? "<Select a Reason>" : "<None Given>",
    },
    ...(cancellationReasons.data ?? []).map((x) => ({
      value: x.id,
      label: x.text,
    })),
  ];

  return (
    <ReactModal onClose={onCancel} isOpen={isOpen} width={600}>
      {cancellationReasons.isLoading || settings.isLoading ? (
        <Loader />
      ) : (
        <Box p={4}>
          <Text fontWeight={600} mb={5} fontSize={4}>
            Are you sure you'd like to cancel this conversation?
          </Text>
          {options.length > 1 && (
            <FormSelect
              label="Reason"
              options={options}
              value={reason}
              onChange={(ev) => setReason(ev.target.value)}
            />
          )}
          <FormToggle
            mb={5}
            label="Cancel all?"
            helpText="Cancel every instance of this conversation"
            value={all}
            onChange={setAll}
          />
          <Flex style={{ gap: 6 }} justifyContent={"flex-end"}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button
              color="danger"
              disabled={reasonRequired && reason === ""}
              onClick={() => onConfirm(all, reason)}
            >
              Confirm
            </Button>
          </Flex>
        </Box>
      )}
    </ReactModal>
  );
};
